import * as P from 'prop-types';

const propTypes = {
  text: P.string.isRequired,
  title: P.string.isRequired,
  step: P.string.isRequired,
  image: P.string.isRequired,
};

export default {
  propTypes,
  defaultProps: {},
};
